var dropdownItemDescription = 'fx_2d2fb1e5_1vzbjdd0';

export { dropdownItemDescription };
//# sourceMappingURL=itemDescription.vanilla.mjs.map
